import { ParcelamentoContainer, ParcelamentoLabel } from "../style";
import FixedCondition from "./FixedCondition";
import { Condicao } from "../../../types/Parcelamento";

interface FixedParcelamentoProps {
  qtdDias: string;
  changeParcelamento: (value: string) => void;
  condicoes: Condicao[];
  codigoParcelamentoEspecial?: string | number;
  useEspecialConditions: boolean;
  disabled?: boolean;
}

function FixedParcelamento({
  qtdDias,
  changeParcelamento,
  condicoes,
  codigoParcelamentoEspecial,
  useEspecialConditions,
  disabled = false,
}: FixedParcelamentoProps) {
  return (
    <>
      <ParcelamentoContainer>
        <ParcelamentoLabel>
          <span>Condições especiais:</span>
          <FixedCondition
            qtdDias={qtdDias}
            changeParcelamento={changeParcelamento}
            condicoes={condicoes}
            codigoParcelamentoEspecial={codigoParcelamentoEspecial}
            useEspecialConditions={useEspecialConditions}
            disabled={disabled}
          />
        </ParcelamentoLabel>
      </ParcelamentoContainer>
    </>
  );
}

export default FixedParcelamento;
